export default "__VITE_ASSET__0b1697ec__"